'use strict';
/* global Deno -- Deno case */
module.exports = typeof Deno == 'object' && Deno && typeof Deno.version == 'object';



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/engine-is-deno.js
// module id = 342
// module chunks = 0